module.exports = __webpack_public_path__ + "img/chatBotIcon.3d241e12.png";